import { useNavigate } from "react-router-dom";
import './login.css'
import axios from "axios";
import { api_url } from "../../constants/data";
import { useState } from "react";
import { useDispatch } from "react-redux";


const Login = () => {
    const navigate = useNavigate(); // Initialize the navigate function
    const[loader, setLoader] = useState(false)
    const[email, setEmail] = useState(null)
    const[password, setPassword] = useState(null)
    const[error, setError] = useState(null)
    const dispatch = useDispatch()

    const submit = (e) => {
        e.preventDefault()
        setLoader(true)
        setError(null)
        axios.post(`${api_url}/login`, {
            email,
            password
        }).then(res => {
            const response = res.data

            localStorage.setItem('auth_token', response.token)

            dispatch({
                type: 'SIGN_IN',
                payload: {
                    user: response.user,
                    access_token: response.token
                }
            })
            window.location.href = '/dashboard'
        }).catch(err => {
            console.error(err)
            setError(err.response.data.error)
        }).finally(() => {
            setLoader(false)
        })
    }
    

    return (
        <>
            <div className="login_wrapper">
                <form onSubmit={submit} id="login">
                    <p style={{fontSize: '20px'}}>შესვლა</p>
                    <p>გთხოვთ შესასვლელად შეიყვანოთ მეილი და პაროლი.</p>
                    <span className="errror">{error}</span>    
                    <label for="username">ელ-ფოსტა</label>
                    <input type="text" placeholder="ელ-ფოსტა" id="email" onChange={(e) => setEmail(e.target.value)} />

                    <label for="password">პაროლი</label>
                    <input type="password" placeholder="პაროლი" id="password" onChange={(e) => setPassword(e.target.value)} />

                    <button type="submit">შესვლა</button>
                </form>
            </div>
        </>
    )
}
  
export default Login